import { render } from "./DocumentReviewPage.vue?vue&type=template&id=69dc4aa4&scoped=true"
import script from "./DocumentReviewPage.vue?vue&type=script&lang=js"
export * from "./DocumentReviewPage.vue?vue&type=script&lang=js"

import "./document-review/detailColumns.css?vue&type=style&index=0&id=69dc4aa4&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69dc4aa4"]])

export default __exports__